import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../ApiUrl/meta_api";
import Footer from "../../Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import "../css/Course.css";
import {
  FaLaptopCode,
  FaProjectDiagram,
  FaHandsHelping,
  FaUserTie,
} from "react-icons/fa";
import { useLocation } from "react-router-dom";

// Import your PDF files
import pdfFile from "../assets/CYBERSECURITY.pdf";
import pdfFile1 from "../assets/DATA_ANALYTICS.pdf";
import pdfFile2 from "../assets/ORACLE_SQL.pdf";
import pdfFile3 from "../assets/POWER_BI.pdf";
import pdfFile4 from "../assets/PYTHON.pdf";
import pdfFile5 from "../assets/SOFTWARE_TESTING.pdf";
import pdfFile6 from "../assets/TABLEAU.pdf";

const Courses = () => {
  const location = useLocation();
  const [meta, setMeta] = useState({});

  const [showModal, setShowModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [hoveredCard, setHoveredCard] = useState(null);
  const [showDownload, setShowDownload] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false,
      offset: 100,
      delay: 100,
    });

    // Directly access about_page from data
    const CourseMeta = data[0]?.course_page;

    // Set meta state if AboutMeta exists
    if (CourseMeta) {
      setMeta(CourseMeta);
    }
  }, []);

  // use location
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  const handleCourseView = (courseName) => {
    const courseNameMap = {
      Cybersecurity: "Cybersecurity",
      DATA_ANALYTICS: "Data Analytics",
      Oracle_SQL: "Oracle SQL",
      Power_BI: "Power BI",
      Python: "Python",
      Software_Testing: "Software Testing",
      Tableau: "Tableau",
    };

    const displayName = courseNameMap[courseName] || courseName;
    setSelectedCourse(displayName);
    setShowModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Simple validation
    if (!formData.name || !formData.email || !formData.phone) {
      alert("Please fill all fields");
      return;
    }

    setShowModal(false);
    setShowDownload(true);

    // Reset form
    setFormData({
      name: "",
      email: "",
      phone: "",
    });
  };

  const handleDownload = () => {
    // Map display names back to PDF file keys
    const displayNameToPdfKey = {
      Cybersecurity: "CYBERSECURITY",
      "Data Analytics": "DATA_ANALYTICS",
      "Oracle SQL": "ORACLE_SQL",
      "Power BI": "POWER_BI",
      Python: "PYTHON",
      "Software Testing": "SOFTWARE_TESTING",
      Tableau: "TABLEAU",
    };

    const pdfKey = displayNameToPdfKey[selectedCourse];
    const coursePdfMap = {
      CYBERSECURITY: pdfFile,
      DATA_ANALYTICS: pdfFile1,
      ORACLE_SQL: pdfFile2,
      POWER_BI: pdfFile3,
      PYTHON: pdfFile4,
      SOFTWARE_TESTING: pdfFile5,
      TABLEAU: pdfFile6,
    };

    const pdfFileToDownload = coursePdfMap[pdfKey];

    if (pdfFileToDownload) {
      const link = document.createElement("a");
      link.href = pdfFileToDownload;
      link.download = `${pdfKey}_Syllabus.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert(`Syllabus not available for ${selectedCourse}`);
    }

    setShowDownload(false);
  };

  const servicesmap = [
    {
      title: "Hands-On Learning",
      description:
        "Real-time coding and software practice with immediate feedback",
      icon: <FaLaptopCode />,
    },
    {
      title: "Mini Projects",
      description:
        "Apply concepts to real-world scenarios through practical case studies",
      icon: <FaProjectDiagram />,
    },
    {
      title: "Personal Support",
      description: "One-on-one doubt-clearing sessions when you need help",
      icon: <FaHandsHelping />,
    },
    {
      title: "Career Focus",
      description:
        "Job-ready skills development, not just theoretical knowledge",
      icon: <FaUserTie />,
    },
  ];

  return (
    <HelmetProvider>
      <div className="courses-page" style={{ overflowX: "hidden" }}>
        <Helmet>
          <title>{meta?.title || "Courses - Berlin Technovation"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Our curriculum is updated with the latest industry trends and tools. With flexible learning options and dedicated support, we ensure your growth every step of the way. Join us to gain a competitive edge in your career."
            }
          />
        </Helmet>
        {/* Hero Section */}
        <div
          style={{ width: "100%" }}
          data-aos="fade-down"
          data-aos-delay="200"
        >
          <div
            className="position-relative"
            style={{
              backgroundImage: `url(${require("../../Img/images/BannerImage/CourseBanner.jpg")})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              height: "350px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                zIndex: 1,
              }}
            ></div>

            {/* Centered Heading */}
            <div
              className="position-absolute top-50 start-50 translate-middle text-center"
              style={{ zIndex: 2 }}
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <h1 className="fw-bold" style={{ color: "#008cff" }}>
                Courses
              </h1>
            </div>

            {/* Breadcrumb */}
            <div
              className="container h-100 d-flex align-items-end pb-4"
              style={{ zIndex: 2, position: "relative" }}
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <nav aria-label="breadcrumb">
                <ol
                  className="breadcrumb mb-0 px-3 py-2 rounded d-flex align-items-center"
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                    display: "flex",
                  }}
                >
                  <li className="breadcrumb-item d-flex align-items-center">
                    <button
                      onClick={() => navigate("/")}
                      className="btn btn-link p-0 text-decoration-none"
                      style={{
                        color: "#0663ad",
                        fontWeight: "bold",
                        background: "none",
                        border: "none",
                      }}
                    >
                      Home
                    </button>
                  </li>
                  <li
                    className="breadcrumb-item active d-flex align-items-center"
                    aria-current="page"
                    style={{ color: "black" }}
                  >
                    Courses
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        {/* Why Choose Section */}
        <div className="container mt-5">
          <div className="container">
            <div className="about-content">
              <div
                className="about-text"
                data-aos="fade-right"
                data-aos-delay="1000"
              >
                <div className="row ">
                  <div className="col-lg-9">
                    <div className="" data-aos="zoom-in">
                      <h2 className=" fw-bold mb-3">
                        <span style={{ color: "#0663ad" }}>Why</span>{" "}
                        <span className="text-dark">Choose Our Course</span>
                      </h2>
                      <div className="section-divider  mb-4"></div>
                    </div>
                  </div>
                </div>
                <p style={{ textAlign: "justify" }}>
                  Why choose our course? We offer expert-led training designed
                  to give you practical skills for real-world success. Our
                  curriculum is updated with the latest industry trends and
                  tools. With flexible learning options and dedicated support,
                  we ensure your growth every step of the way. Join us to gain a
                  competitive edge in your career.
                </p>

                <p style={{ textAlign: "justify" }}>
                  Our course is designed to provide practical, industry-relevant
                  skills through expert-led training, real-world projects, and
                  hands-on learning. Whether you're a beginner or looking to
                  upskill, we offer personalized support, flexible learning
                  options, and a curriculum that keeps pace with current
                  trends—helping you gain the confidence and knowledge to
                  succeed in your career.
                </p>
              </div>

              <div
                className="about-image"
                data-aos="fade-left"
                data-aos-delay="100"
              >
                <div className="image-wrapper">
                  <img
                    src={require("../../Img/images/why choose course.jpg")}
                    alt="Why Choose Our Course"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="cybersecurity"></div>
        {/* Training Programs Header */}
        <div className="text-center mt-5" data-aos="fade-up">
          <h2 className="fw-bold mb-4">
            <span style={{ color: "#0663ad" }}>Our</span>{" "}
            <span className="text-dark">Training Programs</span>
          </h2>
          <div className="section-divider mx-auto mb-4"></div>
        </div>

        <div className="container py-5">
          {/* First Row - 4 Cards */}
          <div className="row mb-4 d-flex justify-content-center">
            {/* Card 1 - Cybersecurity */}
            <div
              className="col-md-6 col-lg-3 mb-4"
              data-aos="fade-up"
              data-aos-delay="100"
              onMouseEnter={() => setHoveredCard(1)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div
                className="card h-100  shadow course-card"
                style={{
                  border: "none",
                  transform: hoveredCard === 1 ? "translateY(-10px)" : "none",
                  transition: "all 0.3s ease",
                }}
              >
                <div className="card-img-container">
                  <img
                    src={require("../../Img/images/Course.Cybersecurity.jpg")}
                    alt="Cybersecurity"
                    className="card-img-top"
                  />
                </div>
                <div
                  className="card-header py-3"
                  style={{
                    backgroundColor: "#0663ad",
                    color: "white",
                    borderBottom: "3px solid #008cff",
                  }}
                >
                  <h5 className="card-title mb-0 text-center fs-6">
                    CYBERSECURITY
                  </h5>
                </div>
                <div
                  className="card-body d-flex flex-column"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <div className="d-flex justify-content-between align-items-center gap-3  mb-3">
                    <span
                      className="badge rounded-pill p-2 "
                      style={{ backgroundColor: "#1cc88a", color: "white" }}
                    >
                      Intermediate
                    </span>
                    <span className="text-muted" style={{ fontSize: "14px" }}>
                      30-45 days
                    </span>
                  </div>

                  <h6 className="card-subtitle mb-2">Technology / Security</h6>

                  <p className="para" style={{ color: "#333", fontSize: "14px" }}>
                    Cybersecurity safeguards digital systems and data from
                    unauthorized access, breaches, and cyber threats.
                  </p>

                  <button
                    className="btn w-100 mt-1 course-btn"
                    style={{
                      backgroundColor: "#0663ad",
                      fontSize: "13px",
                      color: "white",
                      border: "none",
                    }}
                    onClick={() => handleCourseView("Cybersecurity")}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>

            {/* Card 2 - Data Analytics */}
            <div
              className="col-md-6 col-lg-3 mb-4"
              data-aos="fade-up"
              data-aos-delay="200"
              onMouseEnter={() => setHoveredCard(2)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div
                className="card h-100  shadow course-card"
                style={{
                  border: "none",
                  transform: hoveredCard === 2 ? "translateY(-10px)" : "none",
                  transition: "all 0.3s ease",
                }}
              >
                <div className="card-img-container">
                  <img
                    src={require("../../Img/images/Course.Data-analysis.jpg")}
                    alt="Data Analytics"
                    className="card-img-top"
                  />
                </div>
                <div
                  className="card-header py-3"
                  style={{
                    backgroundColor: "#0663ad",
                    color: "white",
                    borderBottom: "3px solid #008cff",
                  }}
                >
                  <h5 className="card-title mb-0 text-center fs-6">
                    DATA ANALYTICS
                  </h5>
                </div>
                <div
                  className="card-body d-flex flex-column"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-3 gap-3">
                    <span
                      className="badge rounded-pill p-2 "
                      style={{ backgroundColor: "#1cc88a", color: "white" }}
                    >
                      Intermediate
                    </span>
                    <span className="text-muted" style={{ fontSize: "14px" }}>
                      30-45 days
                    </span>
                  </div>

                  <h6 className="card-subtitle mb-2 ">Data Science / AI</h6>

                  <p id="para" style={{ color: "#333", fontSize: "14px" }}>
                    Data Analytics is the process of analyzing raw data to find
                    patterns and support decision-making
                  </p>
                  <button 
                    className="btn w-100 mt-1 course-btn"
                    style={{
                      backgroundColor: "#0663ad",
                      fontSize: "13px",
                      color: "white",
                      border: "none",
                    }}
                    onClick={() => handleCourseView("DATA_ANALYTICS")}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>

            {/* Card 3 - Oracle SQL */}
            <div
              className="col-md-6 col-lg-3 mb-4"
              data-aos="fade-up"
              data-aos-delay="300"
              onMouseEnter={() => setHoveredCard(3)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div
                className="card h-100  shadow course-card"
                style={{
                  border: "none",
                  transform: hoveredCard === 3 ? "translateY(-10px)" : "none",
                  transition: "all 0.3s ease",
                }}
              >
                <div className="card-img-container">
                  <img
                    src={require("../../Img/images/Course.sql.jpg")}
                    alt="Oracle SQL"
                    className="card-img-top"
                  />
                </div>
                <div
                  className="card-header py-3"
                  style={{
                    backgroundColor: "#0663ad",
                    color: "white",
                    borderBottom: "3px solid #008cff",
                  }}
                >
                  <h5 className="card-title mb-0 text-center fs-6">
                    ORACLE SQL
                  </h5>
                </div>
                <div
                  className="card-body d-flex flex-column"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                    <span
                      className="badge rounded-pill p-2"
                      style={{ backgroundColor: "#1cc88a", color: "white" }}
                    >
                      Intermediate
                    </span>
                    <span className="text-muted" style={{ fontSize: "14px" }}>
                      30-45 days
                    </span>
                  </div>

                  <h6 className="card-subtitle mb-2 ">Database / Technology</h6>

                  <p className="para" style={{ color: "#333", fontSize: "14px" }}>
                    Learn Oracle SQL for efficient database management,
                    querying, and data manipulation.
                  </p>

                  <button
                    className="btn w-100 mt-1 course-btn"
                    style={{
                      backgroundColor: "#0663ad",
                      fontSize: "13px",
                      color: "white",
                      border: "none",
                    }}
                    onClick={() => handleCourseView("Oracle_SQL")}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>

            {/* Card 4 - Power BI */}
            <div
              className="col-md-6 col-lg-3 mb-4"
              data-aos="fade-up"
              data-aos-delay="400"
              onMouseEnter={() => setHoveredCard(4)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div
                className="card h-100  shadow course-card"
                style={{
                  border: "none",
                  transform: hoveredCard === 4 ? "translateY(-10px)" : "none",
                  transition: "all 0.3s ease",
                }}
              >
                <div className="card-img-container">
                  <img
                    src={require("../../Img/images/Course.Powerbi.jpg")}
                    alt="Power BI"
                    className="card-img-top"
                  />
                </div>
                <div
                  className="card-header py-3"
                  style={{
                    backgroundColor: "#0663ad",
                    color: "white",
                    borderBottom: "3px solid #008cff",
                  }}
                >
                  <h5 className="card-title mb-0 text-center fs-6">POWER BI</h5>
                </div>
                <div
                  className="card-body d-flex flex-column"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                    <span
                      className="badge rounded-pill p-2"
                      style={{ backgroundColor: "#1cc88a", color: "white" }}
                    >
                      Intermediate
                    </span>
                    <span className="text-muted" style={{ fontSize: "14px" }}>
                      30-45 days
                    </span>
                  </div>

                  <h6 className="card-subtitle mb-2">Data Science / AI</h6>

                  <p className="para" style={{ color: "#333", fontSize: "14px" }}>
                    Use Power BI to turn raw data into interactive dashboards
                    and insightful reports for smarter business decisions
                  </p>

                  <button
                    className="btn w-100 mt-auto course-btn"
                    style={{
                      backgroundColor: "#0663ad",
                      fontSize: "13px",
                      color: "white",
                      border: "none",
                    }}
                    onClick={() => handleCourseView("Power_BI")}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>

            {/* Card 5 - Python */}
            <div
              className="col-md-6 col-lg-3 mb-4"
              data-aos="fade-up"
              data-aos-delay="100"
              onMouseEnter={() => setHoveredCard(5)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div
                className="card h-100 shadow course-card"
                style={{
                  border: "none",
                  transform: hoveredCard === 5 ? "translateY(-10px)" : "none",
                  transition: "all 0.3s ease",
                }}
              >
                <div className="card-img-container">
                  <img
                    src={require("../../Img/images/Course.Python.png")}
                    alt="Python"
                    className="card-img-top"
                  />
                </div>
                <div
                  className="card-header py-3"
                  style={{
                    backgroundColor: "#0663ad",
                    color: "white",
                    borderBottom: "3px solid #008cff",
                  }}
                >
                  <h5 className="card-title mb-0 text-center fs-6">PYTHON</h5>
                </div>
                <div
                  className="card-body d-flex flex-column"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                    <span
                      className="badge rounded-pill p-2"
                      style={{ backgroundColor: "#1cc88a", color: "white" }}
                    >
                      Intermediate
                    </span>
                    <span className="text-muted" style={{ fontSize: "14px" }}>
                      30-45 days
                    </span>
                  </div>

                  <h6 className="card-subtitle mb-2 ">Programming</h6>

                  <p className="" style={{ color: "#333", fontSize: "14px" }}>
                    Learn Python programming for data science, automation, web
                    development, and AI applications.
                  </p>

                  <button
                    className="btn w-100 mt-auto course-btn"
                    style={{
                      backgroundColor: "#0663ad",
                      fontSize: "13px",
                      color: "white",
                      border: "none",
                    }}
                    onClick={() => handleCourseView("Python")}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>

            {/* Card 6 - Software Testing */}
            <div
              className="col-md-6 col-lg-3 mb-4"
              data-aos="fade-up"
              data-aos-delay="200"
              onMouseEnter={() => setHoveredCard(6)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div
                className="card h-100  shadow course-card"
                style={{
                  border: "none",
                  transform: hoveredCard === 6 ? "translateY(-10px)" : "none",
                  transition: "all 0.3s ease",
                }}
              >
                <div className="card-img-container">
                  <img
                    src={require("../../Img/images/Course.Software Testing.jpg")}
                    alt="Software Testing"
                    className="card-img-top"
                  />
                </div>
                <div
                  className="card-header py-3"
                  style={{
                    backgroundColor: "#0663ad",
                    color: "white",
                    borderBottom: "3px solid #008cff",
                  }}
                >
                  <h5 className="card-title mb-0 fs-6 text-center">
                    SOFTWARE TESTING
                  </h5>
                </div>
                <div
                  className="card-body d-flex flex-column"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                    <span
                      className="badge rounded-pill p-2"
                      style={{ backgroundColor: "#1cc88a", color: "white" }}
                    >
                      Intermediate
                    </span>
                    <span className="text-muted" style={{ fontSize: "14px" }}>
                      30-45 days
                    </span>
                  </div>

                  <h6 className="card-subtitle mb-2 ">Technology</h6>

                  <p className="" style={{ color: "#333", fontSize: "14px" }}>
                    Learn essential software testing tools, methods, and best
                    practices for quality software development.
                  </p>

                  <button
                    className="btn w-100 mt-1 course-btn"
                    style={{
                      backgroundColor: "#0663ad",
                      fontSize: "13px",
                      color: "white",
                      border: "none",
                    }}
                    onClick={() => handleCourseView("Software_Testing")}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>

            {/* Card 7 - Tableau */}
            <div
              className="col-md-6 col-lg-3 mb-4"
              data-aos="fade-up"
              data-aos-delay="300"
              onMouseEnter={() => setHoveredCard(7)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div
                className="card h-100  shadow course-card"
                style={{
                  border: "none",
                  transform: hoveredCard === 7 ? "translateY(-10px)" : "none",
                  transition: "all 0.3s ease",
                }}
              >
                <div className="card-img-container">
                  <img
                    src={require("../../Img/images/tableau.2.jpg")}
                    alt="Tableau"
                    className="card-img-top"
                  />
                </div>
                <div
                  className="card-header py-3"
                  style={{
                    backgroundColor: "#0663ad",
                    color: "white",
                    borderBottom: "3px solid #008cff",
                  }}
                >
                  <h5 className="card-title mb-0 text-center fs-6">TABLEAU</h5>
                </div>
                <div
                  className="card-body d-flex flex-column"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                    <span
                      className="badge rounded-pill p-2"
                      style={{ backgroundColor: "#1cc88a", color: "white" }}
                    >
                      Intermediate
                    </span>
                    <span className="text-muted" style={{ fontSize: "14px" }}>
                      30-45 days
                    </span>
                  </div>

                  <h6 className="card-subtitle mb-2 ">Data Science</h6>

                  <p id="tableau" style={{ color: "#333", fontSize: "14px" }}>
                    Master Tableau skills to efficiently create interactive
                    dashboards and communicate key data insights clearly.
                  </p>

                  <button
                    className="btn w-100  mt-1 course-btn"
                    style={{
                      backgroundColor: "#0663ad",
                      fontSize: "13px",
                      color: "white",
                      border: "none",
                    }}
                    onClick={() => handleCourseView("Tableau")}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What You Will Gain Section */}
        <div className="container mt-5">
          <div className="row align-items-center">
            {/* Left Side - Image */}
            <div
              className="col-lg-6 mb-4 mb-lg-0"
              data-aos="fade-left"
              data-aos-delay="100"
            >
              <div className="image-wrapper">
                <img
                  src={require("../../Img/images/What You Will Gain.jpg")}
                  alt="What You Will Gain"
                  className="img-fluid rounded"
                />
              </div>
            </div>

            {/* Right Side - Text Content */}
            <div
              className="col-lg-6"
              data-aos="fade-right"
              data-aos-delay="1000"
            >
              <div data-aos="zoom-in" className="">
                <h2 className="fw-bold mb-3">
                  <span style={{ color: "#0663ad" }}>What</span>{" "}
                  <span className="text-dark">You Will Gain</span>
                </h2>
                <div
                  className="section-divider  mb-4"
                  style={{ marginLeft: "100px" }}
                ></div>
              </div>

              <p style={{ textAlign: "justify" }}>
                By enrolling in our course, you'll gain in-depth knowledge,
                practical skills, and hands-on experience tailored to real-world
                applications. You'll build a strong foundation in key concepts,
                work on industry-relevant projects, and develop the confidence
                to apply your learning professionally. Plus, you'll receive a
                certificate of completion to showcase your expertise.
              </p>

              <p style={{ textAlign: "justify" }}>
                The develop practical skills and industry-relevant knowledge
                through expert-led training and real-world projects. You'll
                build confidence by working hands-on and applying your learning
                in professional contexts. Whether you're a beginner or
                upskilling, our flexible, supportive approach ensures meaningful
                progress. Plus, you'll earn a certificate to validate your
                expertise.
              </p>
            </div>
          </div>
        </div>

        <section className="py-5 mt-5 ">
          <div className="container" id="our-service">
            <h2
              className="text-center fw-bold mb-4"
              style={{ color: "#008cff " }}
            >
              Our <span className="text-dark">Training Methods</span>
            </h2>
            <div className="section-divider  mb-0"></div>
            <div className="row g-4 mt-1">
              {servicesmap.map((service, index) => (
                <div key={index} className="col-md-6 col-lg-3">
                  <div
                    className="card h-100 shadow border-0 rounded-4 service-card"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    id="service-card"
                  >
                    <div className="card-body text-center p-4">
                      <div
                        className="fs-1 mb-3 service-icon"
                        style={{ color: "#008cff" }}
                      >
                        {service.icon}
                      </div>
                      <h5 className="card-title mb-2">{service.title}</h5>
                      <p className="card-text text-muted small">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <div className="container mt-5 mb-5">
          <div className="container mt-5">
            <div className="about-content mt-5">
              <div
                className="about-text"
                data-aos="fade-right"
                data-aos-delay="1000"
              >
                <div className="row ">
                  <div className="col-lg-9">
                    <div className="" data-aos="zoom-in">
                      <h2 className=" fw-bold mb-3">
                        <span style={{ color: "#0663ad" }}>Certificate</span>{" "}
                        <span className="text-dark"> of Completion</span>
                      </h2>
                      <div className="section-divider  mb-4"></div>
                    </div>
                  </div>
                </div>
                <p style={{ textAlign: "justify" }}>
                  Every student who successfully completes a course receives a
                  recognized Certificate of Completion. This certificate
                  reflects your commitment, knowledge, and practical skills in
                  the subject. It's a valuable asset when applying for jobs or
                  advancing your career, helping you stand out to employers.
                </p>
              </div>

              <div
                className="about-image"
                data-aos="fade-left"
                data-aos-delay="100"
              >
                <div className="image-wrapper">
                  <img
                    src={require("../../Img/images/Certificate of Completion.jpg")}
                    alt="Certificate of Completion"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />

        {/* Enhanced Modal */}
        {showModal && (
          <div
            className="modal modal-enhanced fade show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content modal-content-enhanced"
                style={{ maxHeight: "600px", overflowY: "auto" }}
                data-aos="zoom-in"
              >
                <div
                  className="modal-header border-0 pb-2"
                  style={{
                    background: "linear-gradient(135deg, #0663ad, #008cff)",
                    padding: "0.75rem 1rem",
                  }}
                >
                  <h3
                    className="modal-title text-white fw-bold"
                    style={{ fontSize: "1rem" }}
                  >
                    <i
                      className="bi bi-mortarboard me-2"
                 
                    ></i>
                    Course Enrollment
                  </h3>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowModal(false)}
                    style={{ fontSize: "0.7rem" }}
                  ></button>
                </div>
                <div
                  className="modal-body p-3"
                  style={{
                    background: "linear-gradient(180deg, #f8f9fa, white)",
                  }}
                >
                  <div className="text-center mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center  rounded-circle mb-2"
                      style={{ width: "50px", height: "50px",backgroundColor:"#008cff" }}
                    >
                      <i className="bi bi-book text-dark fs-4"></i>
                    </div>
                    <p className="text-muted" style={{ fontSize: "0.8rem" }}>
                      Ready to start your learning journey?
                    </p>
                  </div>

                  <form onSubmit={handleFormSubmit}>
                    <div className="mb-2">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Full Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="form-control form-control-enhanced form-control-sm"
                        required
                        placeholder="Enter your full name"
                        value={formData.name}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="mb-2">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Email Address
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="form-control form-control-enhanced form-control-sm"
                        required
                        placeholder="Enter your email address"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="mb-2">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Mobile Number
                      </label>
                      <input
                        type="number"
                        name="phone"
                        className="form-control form-control-enhanced form-control-sm"
                        required
                        placeholder="Enter your mobile number"
                        value={formData.phone}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Course
                      </label>
                      <select
                        className="form-select form-control-enhanced form-select-sm"
                        value={selectedCourse}
                        disabled
                        onChange={(e) => setSelectedCourse(e.target.value)}
                      >
                        <option value="">Choose your course</option>
                        <option>Cybersecurity</option>
                        <option>Data Analytics</option>
                        <option>Oracle SQL</option>
                        <option>Power BI</option>
                        <option>Python</option>
                        <option>Software Testing</option>
                        <option>Tableau</option>
                      </select>
                    </div>

                    <div className="d-flex gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-secondary px-3 py-1 rounded-pill"
                        onClick={() => setShowModal(false)}
                        style={{ fontSize: "0.8rem" }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-submit text-white px-3 py-1 rounded-pill"
                        style={{
                          fontSize: "0.8rem",
                          backgroundColor: "#0663ad",
                          transition: "all 0.3s ease",
                        }}
                       
                      >
                        <i className="bi bi-send me-1"></i>
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Download Confirmation Popup */}
        {showDownload && (
          <div
            className="modal fade show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content shadow-lg rounded-3">
                {/* Modal Header */}
                <div
                  className="modal-header"
                  style={{ backgroundColor: "#0663ad", color: "white" }}
                >
                  <h5 className="modal-title" style={{ fontSize: "1rem" }}>
                    Download Confirm
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowDownload(false)}
                  ></button>
                </div>

                {/* Modal Body */}
                <div className="modal-body text-center text-black">
                  <h5 style={{ fontSize: "0.8rem" }}>
                    Do you want to download the syllabus for {selectedCourse}?
                  </h5>
                </div>

                {/* Modal Footer */}
                <div className="modal-footer d-flex justify-content-center">
                  <button
                    className="btn btn-outline-secondary px-3 py-1 rounded-pill"
                    style={{ fontSize: "0.8rem" }}
                    onClick={() => setShowDownload(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-submit text-white px-3 py-1 rounded-pill"
                    style={{
                      fontSize: "0.8rem",
                      backgroundColor: "#0663ad",
                      transition: "all 0.3s ease",
                    }}
                 
                    onClick={handleDownload}
                  >
                    Download
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </HelmetProvider>
  );
};

export default Courses;
